import { Box } from "@chakra-ui/react";
import { Col, Row } from "antd";
import Field from "ui/components/Input/Field";
import InputMoney from "ui/components/Input/InputMoney";
import SelectIntervaloPeriodo from "ui/components/Input/SelectIntervaloPeriodo";
import { RegraReservaComponentProps } from "..";

export default function PeriodoAntecedenciaCancelarReserva({
  control,
  watch,
  getNameLabel,
}: RegraReservaComponentProps) {
  const tipoIntervaloAntecedenciaCancelarReserva = watch(
    "tipoIntervaloAntecedenciaCancelarReserva"
  );
  return (
    <Box mb="48px">
      <Row gutter={32}>
        <Col sm={6}>
          <Field
            control={control}
            label="Formato de tempo"
            name="tipoIntervaloAntecedenciaCancelarReserva"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectIntervaloPeriodo
                value={field.value}
                defaultValue={null}
                onChange={(value) => {
                  field.onChange(value);
                }}
                isInvalid={isInvalid}
                getPopupContainer={() => document.body}
              />
            )}
          />
        </Col>

        {tipoIntervaloAntecedenciaCancelarReserva ? (
          <Col sm={6}>
            <Field
              control={control}
              shouldUnregister
              label={getNameLabel(tipoIntervaloAntecedenciaCancelarReserva!)}
              name="antecedenciaCancelarReserva"
              rules={{ required: "Campo obrigatório" }}
              render={({ field, isInvalid }) => (
                <InputMoney
                  isInvalid={isInvalid}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="0"
                  step={1}
                  decimalScale={0}
                  decimalsLimit={0}
                />
              )}
            />
          </Col>
        ) : null}
      </Row>
    </Box>
  );
}
